/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/schedulerobjects/scheduler_reporting.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SchedulerobjectsQueueReport
 */
export interface SchedulerobjectsQueueReport {
    /**
     * 
     * @type {string}
     * @memberof SchedulerobjectsQueueReport
     */
    report?: string;
}

export function SchedulerobjectsQueueReportFromJSON(json: any): SchedulerobjectsQueueReport {
    return SchedulerobjectsQueueReportFromJSONTyped(json, false);
}

export function SchedulerobjectsQueueReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulerobjectsQueueReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report': !exists(json, 'report') ? undefined : json['report'],
    };
}

export function SchedulerobjectsQueueReportToJSON(value?: SchedulerobjectsQueueReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report': value.report,
    };
}

